import ReactDOM from 'react-dom'
import { Main } from 'macguffin'
import Renderer from 'mc_pixi-fiber'
import UI from 'mc_full-slot_ui'
import Game, { Assets, Sagas, Reducer, SettingsPages, LoadingScreen } from './game'
import SplashScreen from './game/components/splash'
import Cheats from './config/cheats'

UI.props = { SettingsPages }
const Components = { UI }

const Demo = []

ReactDOM.render(<Main {...{ Game, Assets, Sagas, Reducer, LoadingScreen, Components, Renderer, Cheats, Demo, SplashScreen }} />, document.getElementById('pixi-box'))
